export type Band = 'no_data' | 'low' | 'mid' | 'high' | 'top';

export interface BandStyle {
  band: Band;
  /** Tailwind class for cell background. */
  bg: string;
  /** Tailwind class for cell foreground text. */
  fg: string;
  /** Maps to the `Badge` primitive's `tone` prop. */
  badgeTone: 'neutral' | 'danger' | 'warning' | 'primary' | 'success';
  /** Human-friendly label for legends / tooltips. */
  label: string;
}

export function bandFor(pct: number | null | undefined): BandStyle {
  if (pct == null) {
    return { band: 'no_data', bg: 'bg-bodydark1', fg: 'text-navy', badgeTone: 'neutral', label: 'No data' };
  }
  if (pct < 50) {
    return { band: 'low', bg: 'bg-danger', fg: 'text-white dark:text-navy', badgeTone: 'danger', label: 'Below 50%' };
  }
  if (pct < 70) {
    return { band: 'mid', bg: 'bg-accent', fg: 'text-navy', badgeTone: 'primary', label: '50-70%' };
  }
  if (pct < 85) {
    return { band: 'high', bg: 'bg-slate/40 dark:bg-slate/70', fg: 'text-navy dark:text-white', badgeTone: 'success', label: '70-85%' };
  }
  return { band: 'top', bg: 'bg-navy', fg: 'text-white', badgeTone: 'success', label: '85% or higher' };
}

export function deltaColor(delta: number | null | undefined): string {
  if (delta == null || delta === 0) return 'text-bodydark2';
  return delta > 0 ? 'text-meta-3' : 'text-danger';
}

export function bandHex(band: Band): string {
  switch (band) {
    case 'top':     return '#1C3B4F';
    case 'high':    return '#83A4B6';
    case 'mid':     return '#FF844B';
    case 'low':     return '#C4321F';
    case 'no_data': return '#DEE4EE';
  }
}

export function deltaBand(delta: number | null | undefined): { bg: string; fg: string } {
  if (delta == null) return { bg: 'bg-bodydark1', fg: 'text-body' };
  if (delta <= -10) return { bg: 'bg-danger', fg: 'text-white' };
  if (delta < 10) return { bg: 'bg-stroke', fg: 'text-body' };
  if (delta <= 25) return { bg: 'bg-primary', fg: 'text-white' };
  return { bg: 'bg-secondary', fg: 'text-white' };
}
